import * as THREE from 'three'
import Project from './Project'
import gsap from 'gsap'
import {SectionBase} from "./SectionBase.js";

export default class PlanungSection extends SectionBase{
    constructor(_options)
    {
        super(_options);
        this.setLighting()

    }

    setGeometries()
    {
        this.geometries = {}
        this.geometries.floor = new THREE.PlaneGeometry(16, 8)
    }

    setMeshes()
    {
        this.meshes = {}

        // this.meshes.boardStructure = this.objects.getConvertedMesh(this.resources.items.projectsBoardStructure.scene.children, { floorShadowTexture: this.resources.items.projectsBoardStructureFloorShadowTexture })
        this.resources.items.areaOpenTexture.magFilter = THREE.NearestFilter
        this.resources.items.areaOpenTexture.minFilter = THREE.LinearFilter
        this.meshes.boardPlane = this.resources.items.projectsBoardPlane.scene.children[0]
        this.meshes.areaLabel = new THREE.Mesh(new THREE.PlaneGeometry(2, 0.5), new THREE.MeshBasicMaterial({ transparent: true, depthWrite: false, color: 0xffffff, alphaMap: this.resources.items.areaOpenTexture }))
        this.meshes.areaLabel.matrixAutoUpdate = false
    }

    setItemConfigs()
    {
        //Todo find positions for showTexture
        this.list = [

            {
                name: 'Base',
                cameraAngle: 'projects',
                x: 85,
                y: -22,
                interactionTypes: [],
                useTiles: true,
                imageSources:
                    [
                        './models/projects/bonhomme10ans/slideA.webp',
                        './models/projects/bonhomme10ans/slideB.webp',
                        './models/projects/bonhomme10ans/slideC.webp'
                    ],
                floorTexture: this.resources.items.projectsBonhomme10ansFloorTexture,
                //floorTextureLeft:this.resources.items.projectsBonhomme10ansFloor1Texture,
                link:
                    {
                        href: 'https://www.tu-darmstadt.de/kompaki/wissenssammlung/wissensnugget_2/detailseiten_2/arbeitsfaehigkeit_uebersicht.de.jsp',
                        x: - 4.8,
                        y: - 2,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions:
                    [
                        //Todo Distinction ohne project als static definiert
                        {type: 'Planung', x: 8, y: -12 },
                    ]
            },
            {
                name: 'Intro',
                cameraAngle: 'projects',
                x: 95,
                y: -15,
                useTiles: true,
                interactionTypes: ['showTexture'],
                floorTexture: this.resources.items.projectsBonhomme10ansFloorTexture,
                link:
                    {
                        href: 'https://www.tu-darmstadt.de/kompaki/wissenssammlung/wissensnugget_2/detailseiten_2/arbeitsfaehigkeit_uebersicht.de.jsp',
                        x: - 14.8,
                        y: - 9,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },


            },
            {
                name: 'Stakeholder',
                x: 115,
                y: -22,
                interactionTypes: [ 'Stakeholder'],
                useTiles: true,
                imageSources:
                    [
                        './models/projects/luni/slideA.webp',
                        './models/projects/luni/slideB.webp',
                        './models/projects/luni/slideC.webp'
                    ],
                floorTexture: this.resources.items.projectsLuniFloorTexture,
                link:
                    {
                        href: 'https://www.tu-darmstadt.de/kompaki/wissenssammlung/wissensnugget_2/detailseiten_2/wissensnugget_5.de.jsp',
                        x: - 4.8,
                        y: - 3,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions:
                    [
                    ]
            },
            {
                name: 'Draganddrop',
                x: 85,
                y: -50,
                useTiles: true,
                interactionTypes: [ 'dragDrop'],
                imageSources:
                    [
                        './models/projects/madbox/slideA.jpg',
                        './models/projects/madbox/slideB.jpg',
                        './models/projects/madbox/slideC.jpg'
                    ],
                floorTexture: this.resources.items.projectsMadboxFloorTexture,
                link:
                    {
                        href: 'https://madbox.io',
                        x: - 4.8,
                        y: - 4,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions:
                    [
                        { type: 'Teleskop',  x: -1.95, y: 4.15 }
                    ]
            },
            {
                name: 'Graveyard',
                x: 115,
                y: -50,
                interactionTypes: ['showDialog1','playAudio'],
                useTiles: true,
                imageSources:
                    [
                        './models/projects/scout/slideA.jpg',
                        './models/projects/scout/slideB.jpg',
                        './models/projects/scout/slideC.jpg'
                    ],
                floorTexture: this.resources.items.projectsScoutFloorTexture,
                link:
                    {
                        href: 'https://fromscout.com',
                        x: - 4.8,
                        y: - 2,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions:
                    [
                    ]
            },
            {
                name: 'Zeitplanung',
                x: 130,
                y: -35,
                interactionTypes: ['zeitplanung'],
                useTiles: true,
                imageSources:
                    [
                        './models/projects/zenly/slideA.jpg',
                        './models/projects/zenly/slideB.jpg',
                        './models/projects/zenly/slideC.jpg'
                    ],
                floorTexture: this.resources.items.projectsScoutFloorTexture,
                link:
                    {
                        href: 'https://zen.ly',
                        x: - 4.8,
                        y: - 4.2,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions:
                    [
                        { type: 'Sanduhr',  x: -5, y: 4.15},
                    ]
            },
        ]
    }

    setZone(x, y, cameraAngle = 'default')
    {
        const totalWidth = this.list.length * (this.interDistance / 2)

        const zone = this.zones.add({
            position: { x: x+2, y: y},
            halfExtents: { x: 12, y: 10},
            data: { cameraAngle: cameraAngle }
        })

        zone.on('in', (_data) =>
        {
            this.camera.angle.set(_data.cameraAngle)
            gsap.to(this.passes.horizontalBlurPass.material.uniforms.uStrength.value, { x: 0, duration: 2 })
            gsap.to(this.passes.verticalBlurPass.material.uniforms.uStrength.value, { y: 0, duration: 2 })
        })

        zone.on('out', () =>
        {
            this.camera.angle.set('default')
            gsap.to(this.passes.horizontalBlurPass.material.uniforms.uStrength.value, { x: this.passes.horizontalBlurPass.strength, duration: 2 })
            gsap.to(this.passes.verticalBlurPass.material.uniforms.uStrength.value, { y: this.passes.verticalBlurPass.strength, duration: 2 })
        })
    }

    setStatic()
    {
        //Todo: Make this compile and delete base distinction
        /*this.objects.add({
            base:this.resources.items.projectsDistinctionsPlanungBase.scene,
            //collision: this.resources.items.PlanungCollision,
            //collision: this.resources.items.distinctionCStaticCollision.scene,
            //floorShadowTexture: this.resources.items.PlanungFloorShadowTexture,
            //floorShadowTexture: this.resources.items.distinctionCStaticFloorShadowTexture,
            offset: new THREE.Vector3(this.x+25, this.y-48, 0),
            mass: 0
        })*/

        this.objects.add({
            base: this.resources.items.distinctionCStaticBase.scene,
            collision: this.resources.items.distinctionCStaticCollision.scene,
            floorShadowTexture: this.resources.items.distinctionCStaticFloorShadowTexture,
            offset: new THREE.Vector3(this.x, this.y, 0),
            mass: 0
        })

    }

    setLighting() {
        const pointLight = new THREE.PointLight(0xffa500, 1.5, 10, 2) // warmes Licht
        pointLight.position.set(this.x, this.y + 1.5, 2)
        // Optional: Lichtvisualisierung zum Debuggen
        // const helper = new THREE.PointLightHelper(pointLight, 0.2)
        // this.container.add(helper)
        this.container.add(pointLight)

    }

    add(_options)
    {
        // Falls x oder y im Projekt definiert ist, nimm sie – sonst Standard-Offset
        const x = typeof _options.x === 'number' ? _options.x : this.x + this.items.length * this.interDistance
        const y = typeof _options.y === 'number' ? _options.y : this.y + (Math.random() - 0.5) * this.positionRandomess

        // Create project
        const project = new Project({
            time: this.time,
            resources: this.resources,
            objects: this.objects,
            areas: this.areas,
            geometries: this.geometries,
            meshes: this.meshes,
            debug: this.debugFolder,
            interactionType: _options.interactionType,
            x: x,
            y: y,
            ..._options
        })

        this.container.add(project.container)

        this.setZone(x, y, _options.cameraAngle || 'default')

        // Add tiles
        if(this.items.length >= 1 && (!_options.useTiles))
        {
            const previousProject = this.items[this.items.length - 1]
            const start = new THREE.Vector2(previousProject.x+7 , previousProject.y)
            const end = new THREE.Vector2(project.x - this.projectHalfWidth, project.y)
            const delta = end.clone().sub(start)
            this.tiles.add({
                start: start,
                delta: delta
            })
        }

        // Save
        this.items.push(project)
    }

    setRoads() {
        let roads;
        roads=[
            {
                start: new THREE.Vector2(69, -30),
                delta: new THREE.Vector2(47, -2)
            },
            {
                start: new THREE.Vector2(119, -37),
                delta: new THREE.Vector2(-17, -16)
            },
            {
                start: new THREE.Vector2(96, -56),
                delta: new THREE.Vector2(-10, 0)
            }
        ]
        roads.forEach((road) => {
            this.tiles.add({
                start: road.start,
                delta: road.delta,
            })
        })
    }

    setWalls() {
        super.setWalls()

        this.walls.add({
            object:
                {
                    ...this.dikes.brickOptions,
                    rotation: new THREE.Euler(0, 0, Math.PI * 0.5)
                },
            shape:
                {
                    type: 'brick',
                    equilibrateLastLine: true,
                    widthCount: 3,
                    heightCount: 2,
                    position: new THREE.Vector3(this.x + 8, this.y + 46, 0),
                    offsetWidth: new THREE.Vector3(1.05, 0, 0),
                    offsetHeight: new THREE.Vector3(0, 0, 0.45),
                    randomOffset: new THREE.Vector3(0, 0, 0),
                    randomRotation: new THREE.Vector3(0, 0, 0.2)
                }
        })

        this.walls.add({
            object: this.dikes.brickOptions,
            shape:
                {
                    type: 'brick',
                    equilibrateLastLine: false,
                    widthCount: 3,
                    heightCount: 2,
                    position: new THREE.Vector3(this.x + 9.9, this.y + 45, 0),
                    offsetWidth: new THREE.Vector3(0, -1.05, 0),
                    offsetHeight: new THREE.Vector3(0, 0, 0.45),
                    randomOffset: new THREE.Vector3(0, 0, 0),
                    randomRotation: new THREE.Vector3(0, 0, 0.2)
                }
        })

        this.walls.add({
            object:
                {
                    ...this.dikes.brickOptions,
                    rotation: new THREE.Euler(0, 0, Math.PI * 0.5)
                },
            shape:
                {
                    type: 'brick',
                    equilibrateLastLine: true,
                    widthCount: 3,
                    heightCount: 2,
                    position: new THREE.Vector3(this.x - 34, this.y + 46, 0),
                    offsetWidth: new THREE.Vector3(1.05, 0, 0),
                    offsetHeight: new THREE.Vector3(0, 0, 0.45),
                    randomOffset: new THREE.Vector3(0, 0, 0),
                    randomRotation: new THREE.Vector3(0, 0, 0.2)
                }
        })

        this.walls.add({
            object: this.dikes.brickOptions,
            shape:
                {
                    type: 'brick',
                    equilibrateLastLine: false,
                    widthCount: 3,
                    heightCount: 2,
                    position: new THREE.Vector3(this.x - 35, this.y + 44, 0),
                    offsetWidth: new THREE.Vector3(0, -1.05, 0),
                    offsetHeight: new THREE.Vector3(0, 0, 0.45),
                    randomOffset: new THREE.Vector3(0, 0, 0),
                    randomRotation: new THREE.Vector3(0, 0, 0.2)
                }
        })

        this.walls.add({
            object: this.dikes.brickOptions,
            shape:
                {
                    type: 'brick',
                    equilibrateLastLine: true,
                    widthCount: 3,
                    heightCount: 2,
                    position: new THREE.Vector3(this.x -35, this.y + 38.5, 0),
                    offsetWidth: new THREE.Vector3(0, -1.05, 0),
                    offsetHeight: new THREE.Vector3(0, 0, 0.45),
                    randomOffset: new THREE.Vector3(0, 0, 0),
                    randomRotation: new THREE.Vector3(0, 0, 0.2)
                }
        })
    }
}